import React from 'react';
/*
import {
  cr,
  gs,
  cmODT,
  useNgnz
} from 'lib';
*/
import * as cmODT from "./_cmODT";
import * as cr from './_cr';
import * as gs from "./_csGbl";
import { useNgnz } from "./_csNgn";

import * as icm from './icm';

export const N = (pz: {
}) => {

//  const _sNgnz = useNgnz();
  const _gUserz = gs.useUserz();
  const _gStgz = gs.useUserz();

  React.useEffect(() => {
    //hf.l(`icvLgn___Rz 26: ${hf.s(_gUserz.crt)}`)
//    const _dmn = _sNgnz.getPrmz('d');
//    hf.l(`icvLgn___Rz 27: ${_dmn}`)
    const _ftn = async () => {

/*
      await _gUserz.saveAsync({
        ornDtm: hfDTM.getNow(),
      });
*/
      await cmODT.setAsync();

/*
      const _b = await icm.setDmnAsync()
      if (_b) {
        if (_gUserz.crt.lgnType == 'k') {
          cr.moveTo({
            pageName: 'icvLgnK10Rz',
          })
        }
        if (_gUserz.crt.lgnType == 's') {
          cr.moveTo({
            pageName: 'icvLgnS10Rz',
          })
        }
        if (_gUserz.crt.lgnType == 'd10') {
          cr.moveTo({
            pageName: 'icvLgnD10Rz',
          })
        }
        if (_gUserz.crt.lgnType == 'd20') {
          cr.moveTo({
            pageName: 'icvLgnD20Rz',
            pmrz: {
              d: 'a',
            },
          })
        }
        if (_gUserz.crt.lgnType == 'd30') {
          cr.moveTo({
            pageName: 'icvLgnD30Rz',
          })
        }
      }
*/
      const _b = await icm.setDmnAsync()
      if (_b) {
        const _sNgnz = useNgnz();
        const _dmnName = await _sNgnz.getPmrzAsync('d')
        if (_gUserz.crt.lgnType == 'k') {
          cr.moveTo({
            pageName: 'icvLgnK10Rz',
            pmrz: {
              d: _dmnName,
            },
          })
        }
        if (_gUserz.crt.lgnType == 's') {
          cr.moveTo({
            pageName: 'icvLgnS10Rz',
            pmrz: {
              d: _dmnName,
            },
          })
        }
        if (_gUserz.crt.lgnType == 'd10') {
          cr.moveTo({
            pageName: 'icvLgnD10Rz',
            pmrz: {
              d: _dmnName,
            },
          })
        }
        if (_gUserz.crt.lgnType == 'd20') {
          cr.moveTo({
            pageName: 'icvLgnD20Rz',
            pmrz: {
              d: _dmnName,
            },
          })
        }
        if (_gUserz.crt.lgnType == 'd30') {
          cr.moveTo({
            pageName: 'icvLgnD30Rz',
            pmrz: {
              d: _dmnName,
            },
          })
        }
      }

    };

    _ftn();

  }, [])

/*
  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        oClds: [
        ]
      }
    })
  );
*/
  return null;
};
